import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import React from 'react';
import { normalizeSearchString } from '../../../../utils/normalizeSearchString';
import { selectWork } from '../../../Api/selectors';
import { fetchCompanyProductsIds, fetchProducts, productSearch } from '../../actions';
import { REQUEST_PRODUCT_SEARCH, REQUEST_COMPANY_PRODUCTS_IDS, REQUEST_PRODUCTS_FILTER } from '../../constants';
import { BaseComponent } from '../../../../components/BaseComponent';
import { SearchSelect } from '../../../../components/SearchSelectComponent';
import { selectProducts, selectCompanyProductsIds } from '../../selectors';

const STATE = {
  string: '',
};

/* eslint-disable react/prefer-stateless-function */
class CompanyProductSelectionComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.fetchCompanyProductsIds(this.props.fetchProducts);
  }

  reset() {
    this.setState({ ...STATE });
  }

  applySelection(product) {
    this.props.onComplete(product.id);
    this.reset();
  }

  onStringChange(evt) {
    let string = evt;
    this.setState({ string });
    if (!string) return;
    this._t = this.timeout(this.search.bind(this), 300, this._t);
  }

  search() {
    const search = normalizeSearchString(this.state.string);
    this.props.search(search, null, result =>
      this.setState({
        result: result.items
          ?.filter(product => product.id != this.state.product?.id)
          ?.filter(product => !this.props.companyProductsIds?.includes(product.id)),
      }),
    );
  }

  render() {
    let products = this.state.string ? this.state.result : this.props.products;

    let options = products
      ?.filter(product => !this.props.companyProductsIds?.includes(product.id))
      ?.map(product => ({
        product,
        value: product?.id,
        label: `${product?.name ?? ''}`,
      }));

    return (
      <SearchSelect
        minWidth="80%"
        isLoading={this.props.workIds || this.props.workProducts || this.props.searching}
        options={options}
        inputValue={this.state.string}
        onInputChange={this.onStringChange.bind(this)}
        onChange={e => {
          if (e.value) {
            this.setState({ selectedProduct: e.product });
            this.applySelection(e?.product);
          }
        }}
      />
    );
  }
}

CompanyProductSelectionComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    workIds: selectWork(REQUEST_COMPANY_PRODUCTS_IDS),
    workProducts: selectWork(REQUEST_PRODUCTS_FILTER),
    searching: selectWork(REQUEST_PRODUCT_SEARCH),
    products: selectProducts(),
    companyProductsIds: selectCompanyProductsIds(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    search(string, vehiclePurposeType, callback) {
      const options = {};
      dispatch(productSearch(string, vehiclePurposeType, options, callback));
    },
    fetchProducts(callback) {
      const options = {};
      dispatch(fetchProducts(options, callback));
    },
    fetchCompanyProductsIds(callback) {
      dispatch(fetchCompanyProductsIds(ownProps.companyId, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyProductSelection = compose(withConnect, withRouter, injectIntl)(CompanyProductSelectionComp);
